import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=08b5a78a"
import script from "./FileInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FileInput.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports